<template>
  <ChatMessageTemplateModalStructure
    :loading="loading"
    :noTemplate="selectedTemplate == null"
  >
    <template #header>
      <ChatMessageTemplateHeader @close="emit('close')">
        下記のテンプレートを削除しますか？
      </ChatMessageTemplateHeader>
    </template>

    <template #detail>
      <ChatMessageTemplateDetailDelete
        v-if="selectedTemplate != null"
        :class="$style.content"
        :template="selectedTemplate"
        @cancel="emit('changeMode', 'view')"
        @delete="handleDelete"
      />
    </template>
  </ChatMessageTemplateModalStructure>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import ChatMessageTemplateHeader from './ChatMessageTemplateHeader.vue'
import ChatMessageTemplateDetailDelete from './ChatMessageTemplateDetailDelete.vue'
import ChatMessageTemplateModalStructure from './ChatMessageTemplateModalStructure.vue'
import { useChatMessageTemplate } from './useChatMessageTemplate'

import type { ChatMessageTemplate } from '@/types/app'
import type { ChatMessageTemplateModalMode } from './types'

const props = defineProps<{
  selectedGuid: Maybe<ChatMessageTemplate['guid']>
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (
    event: 'update:selectedGuid',
    value: Maybe<ChatMessageTemplate['guid']>
  ): void
  (event: 'changeMode', value: ChatMessageTemplateModalMode): void
}>()

const { loading, data, map, deleteTemplate } = useChatMessageTemplate()
const selectedTemplate = computed(() =>
  props.selectedGuid != null ? map.value.get(props.selectedGuid) : null
)

// NOTE: テンプレート削除後は、削除したテンプレートの一個前を選択する
const nextSelectedGuid = computed(() => {
  const currentIndex = data.value.findIndex(
    template => template.guid === props.selectedGuid
  )
  const nextIndex = Math.max(currentIndex - 1, 0)
  const rest = data.value.filter(
    template => template.guid !== props.selectedGuid
  )
  return rest[nextIndex]?.guid
})

const handleDelete = async () => {
  if (selectedTemplate.value == null) {
    return
  }
  const _nextGuid = nextSelectedGuid.value
  await deleteTemplate(selectedTemplate.value.guid)
  emit('update:selectedGuid', _nextGuid)
  emit('changeMode', 'view')
}
</script>

<style lang="scss" module>
.content {
  flex: 1;
}
</style>
